<script>
import AdminFacility from './AdminFacility';
export default {
	mixins: [AdminFacility],
	watch: {
		selectedFacility() {
			this.cancel();
		}
	},
	methods: {
		cancel() {
			this.$emit('cancel');
		}
	}
};
</script>
